import { render } from "./InsightsPage.vue?vue&type=template&id=5cd90526&scoped=true"
import script from "./InsightsPage.vue?vue&type=script&lang=js"
export * from "./InsightsPage.vue?vue&type=script&lang=js"

import "./InsightsPage.vue?vue&type=style&index=0&id=5cd90526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd90526"]])

export default __exports__